// Används när vi lägger till värden som vi sedan direkt vill kunna redigera i tex. Griden i Bokforder
export const NEWLY_ADDED_ID_PREFIX_FOR_UPDATE = 'New_';
